module.exports = __webpack_public_path__ + "img/fig33.c9544f0b.jpg";